export default __webpack_public_path__ + "static/media/lc.7f8469a2.webp";